// extracted by mini-css-extract-plugin
module.exports = {"grey300":"#D1D1D1","btn":"radio_btn__Kclb5","left":"radio_left__HNwUL","right":"radio_right__u1a21","inActive":"radio_inActive__8tk95"};